module.exports = __webpack_public_path__ + "media/images/favicon-5eb526f5e378cfb39f2f7f4f90084e66.ico";